import React, { useEffect, useState, useRef, forwardRef } from 'react';
import dynamic from 'next/dynamic';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LogarithmicScale
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { GrPowerReset } from "react-icons/gr";

const zoomPlugin = dynamic(() => import('chartjs-plugin-zoom'), { ssr: false });

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    LogarithmicScale,
    Title,
    Tooltip,
    Legend
);

const AllocMultiAxisComponent = forwardRef((props , ref) => {
    // const chartRef = useRef(null);
    const [isZoomed, setIsZoomed] = useState(false);
    const { labels, datasets, options , setIsZoomedChart , onZoomClick , vs } = props;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleZoom = () => setIsZoomed(true);
            const chart = ref.current;
            if (chart) {
                chart.options.plugins.zoom.zoom.onZoom = handleZoom;
                chart.options.plugins.zoom.zoom.onZoomComplete = handleZoom;
            }
        }
    }, []);

    useEffect(() => {
        setIsZoomedChart(isZoomed);
    },[isZoomed])
    useEffect(() => {
      if(onZoomClick) {
        resetZoom();
      }
    },[onZoomClick])

    useEffect(() => {
        // Update chart options if labels, datasets, or options change
        if (ref.current) {
            ref.current.update();
        }
    }, [labels, datasets, options]);

    const data = {
        labels: labels,
        datasets: datasets
    };

    const resetZoom = () => {
        if (ref.current) {
            ref.current.resetZoom();
            setIsZoomed(false);
        }
    };
    const pointSizeAdjuster = {
        id: 'pointSizeAdjuster',
        beforeDraw: (chart) => {
            chart.data.datasets.forEach((dataset) => {
                const label = dataset.label || '';
                if (label.includes('100')) {
                    dataset.pointRadius = 2;
                } else if (label === 'SPX Baseline' || label === '') {
                    // Keep original value
                } else {
                    dataset.pointRadius = 5;
                }
            });
        }
    };
    const customCanvasTextPlugin = {
        id: 'customCanvasBackgroundText',
        afterDraw: (chart) => {
            const ctx = chart.ctx;
            const chartArea = chart.chartArea;
            const scales = chart.scales;
            
            if (!chartArea || !scales.x || !scales.y) {
                return;
            }
    
            // Find the baseline dataset (the gray diagonal line)
            const baselineDataset = chart.data.datasets.find(dataset => 
                dataset.label === 'SPX Baseline' && 
                dataset.data && 
                dataset.data.length
            );
    
            if (!baselineDataset) return;
    
            // Get the visible points of the baseline
            const visiblePoints = baselineDataset.data.filter(point => {
                const xPixel = scales.x.getPixelForValue(point.x);
                const yPixel = scales.y.getPixelForValue(point.y);
                return (
                    xPixel >= chartArea.left && 
                    xPixel <= chartArea.right &&
                    yPixel >= chartArea.top && 
                    yPixel <= chartArea.bottom
                );
            });
    
            if (visiblePoints.length < 2) return; // Need at least 2 points to draw text
    
            // Find a good position along the visible line (around 25-30% from the start)
            const index = Math.floor(visiblePoints.length * 0.63);
            const point = visiblePoints[index];
    
            if (point) {
                ctx.save();
    
                const xPixel = scales.x.getPixelForValue(point.x);
                const yPixel = scales.y.getPixelForValue(point.y);
    
                // Set text properties
                ctx.font = '11px Arial';
                ctx.fillStyle = 'rgba(105, 105, 105, 0.8)';
                ctx.textAlign = 'left';
                
                // Position and rotate text
                ctx.translate(xPixel, yPixel);
                ctx.rotate(-Math.PI / 6.9);
                
                ctx.fillText(`${vs} BASELINE`?.toUpperCase(), 0, -10);
                
                ctx.restore();
            }
        }
    };

    return (
        <>
            <Line ref={ref} options={options} data={data} plugins={[pointSizeAdjuster , customCanvasTextPlugin]}/>
            {/* {isZoomed && <button className='absolute top-0 left-2 bg-[#69a4ce] rounded-full w-6 h-6 flex items-center justify-center text-white' onClick={resetZoom}><GrPowerReset /></button>} */}
        </>
    );
});

export default AllocMultiAxisComponent;